import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    globalEventTeaserData,
    TeaserGlobalEventTemplate,
} from "./teaser-global-event.templates";

export default {
    title: "Website/Partial Templates/Teaser/Global Event",
    render: TeaserGlobalEventTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        media: "icon",
        intro: globalEventTeaserData.intro,
        headline: globalEventTeaserData.headline,
        subline: globalEventTeaserData.subline,
    },
    argTypes: {
        media: {
            options: ["icon", "image"],
            control: { type: "radio" },
        },
        intro: {
            control: "text",
        },
        headline: {
            control: "text",
        },
        subline: {
            control: "text",
        },
    },
};

export const Default = {};
